import { Text } from '../primitives/Text';

interface Props {
  sublabel: string;
  size: number | undefined;
}

function formatFileSize(bytes: number) {
  const k = 1000;
  const units = ['B', 'KB', 'MB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const decimals = i > 1 ? 2 : 0;

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(decimals))} ${units[i]}`;
}

export function SubLabel({ sublabel, size }: Props) {
  return (
    <Text fontSize={12} lineHeight="14px" color="gray.400">
      {size ? formatFileSize(size) : sublabel}
    </Text>
  );
}